import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from '../../../../../services/common/common.service';
import { CompanyService } from '../../../../../services/company/company.service';
import { DatePipe } from '@angular/common';
import { EmployeeListService } from '../../../../../services/employee/employee-list.service';
import moment from 'moment';
import { ClassificationService } from '../../../../../services/classification/classification.service';
// import Swal from 'sweetalert2';
import { ToastService } from '../../../../../services/toast.service';
import Swal from 'sweetalert2';
import { AuthService } from '../../../../../services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaterialTimepickerComponent } from 'ngx-material-timepicker';
import { FormChangeTrackerService } from '../../../../../services/form-change-tracker.service';
import { OtMasterService } from '../../../../../services/otmaster/ot-master.service';
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import { ExcelService } from '../../../../../services/export/excel.service';

@Component({
  selector: 'app-tna-authorisation',
  templateUrl: './tna-authorisation.component.html',
  styleUrl: './tna-authorisation.component.scss'
})
export class TnaAuthorisationComponent implements OnInit {
  tnaForm!: FormGroup;
  editTnaForm!: FormGroup;
  submit: boolean = false;
  dateFormat: any = 'dd/MM/yyyy';
  angularDateFormat: any;
  date: any = 'dd-mm-yy';
  startDate: any = null;
  endDate: Date | null = null;
  showTable: boolean = false;
  minDate!: Date;
  currentYear: any = new Date().getFullYear();
  maxDate: Date = new Date(this.currentYear, 11, 31);
  currentDate: any = new Date();

  // Pagination properties
  currentPage: number = 0;
  page = 0;
  size: any = 10;
  pageSize = 10;
  totalRecords: number = 0;

  publicHolidayColor: any;
  weekoffColor: any;
  presentColor: any;
  absentColor: any;

  empAttendanceList: any[] = [];
  otList: any = [];
  presentCount: number = 0;
  absentCount: number = 0;

  // Custom table
  menuId: number = 0;
  myColumns: any[] = [];
  filterPayload: any = '';
  orderby: string = '';
  order: string = '';
  searchQuery: string = '';
  private searchDebounceTimer: any = null;

  hideCompany: any = false;
  employeeList: any = [];
  companyList: any = [];
  selectedClassifications: any = {};
  typeOption: any = [
    { label: 'Late Check-In', value: 'Late Check-In' },
    { label: 'Early Check-Out', value: 'Early Check-Out' },
    { label: 'Absent', value: 'Absent' },
    { label: 'Present', value: 'Present' },
    { label: 'Missed In/Out', value: 'Missed In/Out' },
  ];

  constructor(
    private fb: FormBuilder,
    private commonService: CommonService,
    private companyService: CompanyService,
    private employeeService: EmployeeListService,
    private classificationService: ClassificationService,
    private datePipe: DatePipe,
    private readonly toastService: ToastService,
    private readonly auth: AuthService,
    private readonly modalService: NgbModal,
    private readonly formChangeService: FormChangeTrackerService,
    private readonly otMasterService: OtMasterService,
    private readonly excelService: ExcelService

  ) {
    this.tnaForm = this.fb.group({
      company_id: [null, [Validators.required]],
      employee_id: [null],
      start_date: [null, [Validators.required]],
      end_date: [null, [Validators.required]],
      type: [null]
    });

    // Edit modal form (for editing check-in/check-out times)
    this.editTnaForm = this.fb.group({
      checkin_time: [null, [Validators.required]],
      checkout_time: [null, [Validators.required]],
      remarks: [null, [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.setupInitialData();
    this.setupFormChangeTracking();
    this.getClientCompanylistData();
  }

  role: any = ''
  async setupInitialData() {
    this.menuId = this.auth.selectedMenuID ?? 0;
    const userData: any = this.commonService.getLocalStorageData();
    if (userData) {
      this.role = userData.role;
      if (!userData.client) {
        this.tnaForm?.patchValue({
          company_id: userData.companyID,
        });
        this.patchDefaultDates();
        this.getOtList(userData.companyID);
        this.getDateFormat(userData.companyID);
        this.getClassificationList(userData.companyID);
        this.companyParameter(userData.companyID);
        await this.getEmployeeList(userData?.companyID);
        if (userData.role == 4) {
          this.tnaForm?.patchValue({
            employee_id: userData.userID,
          });
          if (!userData.is_help_desk_supervisor) {
            this.tnaForm.get('employee_id')?.disable();
          }
        }
        this.hideCompany = true;
        this.refreshData();
      }
    }
  }

  patchDefaultDates() {
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    this.startDate = startOfMonth;
    this.endDate = endOfMonth;

    this.tnaForm.patchValue({
      start_date: startOfMonth,
      end_date: endOfMonth
    });
  }

  private getDateFormat(companyId: any): void {
    this.companyService.getParametersById(companyId).subscribe({
      next: (resp) => {
        if (resp?.data?.date_format) {
          this.date = resp?.data?.date_format;
          this.dateFormat = resp?.data?.date_format.replace('mm', 'MM');
          this.angularDateFormat = this.commonService.convertPrimeNGToAngularFormat(this.date);
        }
      },
      error: err => {
        console.error('Error fetching date format:', err);
      }
    });
  }


  getClientCompanylistData() {
    this.companyService.getClientCompanyList().subscribe({
      next: (resp: any) => {
        this.companyList = resp.data;
      },
    });
  }

  onCompanyChange(event: any) {
    this.currentPage = 0;
    this.page = 1;
    this.employeeList = [];
    this.myColumns = [];
    this.tnaForm.patchValue({
      employee_id: null
    })
    this.patchDefaultDates();
    this.getDateFormat(event?.id);
    this.getEmployeeList(event?.id);
    this.companyParameter(event?.id);
    this.selectedClassifications = {};
    this.getClassificationList(event?.id);
    this.getOtList(event?.id);
    this.refreshData();
  }

  onEmployeeChange(event: any) {
    this.currentPage = 0;
    this.page = 1;
    this.refreshData();
  }

  onClearEmployee() {
    this.currentPage = 0;
    this.page = 1;
    this.refreshData();
  }

  onTypeChange(event: any) {
    this.currentPage = 0;
    this.page = 1;
    this.refreshData();
  }

  getEmployeeList(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.employeeService.getRequestEmployeeList({ company_id: id }).subscribe({
        next: (resp) => {
          if (resp && resp?.data?.length > 0) {
            this.employeeList = resp.data.map((emp: any) => ({
              ...emp,
              id: emp.id,
              fullName: `${emp.employeecode} - ${emp.firstname} ${emp.lastname ?? ''}`,
            }));
          } else {
            this.employeeList = [];
          }
          resolve(this.employeeList); // ✅ Always resolve
        },
        error: (err) => {
          this.employeeList = [];
          reject(err); // ✅ Properly reject on error
        },
      });
    });
  }

  classificationList: any = [];
  getClassificationList(id: any) {
    this.classificationService.getAllWithoutPagination({ company_id: id }).subscribe({
      next: (resp) => {
        this.classificationList = resp?.data?.rows ?? [];
        console.log("=--=this.classificationList", this.classificationList);

      }
    });
  }



  isInvalid(controlName: string): boolean {
    const control = this.tnaForm.get(controlName);
    if (!control) return false;

    return (
      (this.submit && control.invalid) ||
      (this.submit && !!control.errors) ||
      (control.invalid && (control.dirty || control.touched))
    );
  }

  onStartDateChange(event: Date): void {
    if (event) {
      this.startDate = new Date(event);
      if (this.endDate && this.endDate < this.startDate) {
        this.endDate = null;
        this.tnaForm.patchValue({ end_date: null });
      }
    }
    this.currentPage = 0;
    this.page = 1;
    this.refreshData();
  }

  onDueDateChange(event: Date): void {
    if (event) {
      this.endDate = new Date(event);
      if (this.startDate && this.endDate < this.startDate) {
        this.endDate = null;
        this.tnaForm.patchValue({ end_date: null });
      }
      this.currentPage = 0;
      this.page = 1;
      this.refreshData();
    }
  }

  companyParameter(id: any): void {
    this.commonService.getCompanyParameters(id).subscribe({
      next: (resp: any) => {
        this.publicHolidayColor = resp?.data?.public_holiday_color;
        this.weekoffColor = resp?.data?.week_off_color;
        this.presentColor = resp?.data?.present_color;
        this.absentColor = resp?.data?.abscent_color;
      }
    });
  }

  private formatDate(date: Date): string | null {
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }

  refreshData(): void {
    if (this.tnaForm.get('start_date')?.value && this.tnaForm.get('end_date')?.value && this.tnaForm.get('company_id')?.value) {
      this.showTable = true;
      this.list();
    }
  }

  list(): void {
    const userData: any = this.commonService.getLocalStorageData();
    if (!userData?.companyID) return;
    let rawData = this.tnaForm.getRawValue();
    let start_date = this.formatDate(this.tnaForm.get('start_date')?.value);
    let end_date = this.formatDate(this.tnaForm.get('end_date')?.value);

    let params: any = {
      company_id: rawData.company_id,
      start_date: start_date,
      end_date: end_date,
      page: this.currentPage,
      size: this.size,
      ...this.commonService.buildFilterPayload(this.filterPayload)
    };
    if (this.orderby) params['orderby'] = this.orderby;
    if (this.order) params['order'] = this.order;
    if (this.searchQuery) params['search'] = this.searchQuery;
    if (rawData.employee_id) {
      params['employee_id'] = rawData.employee_id;
    }
    if (rawData.type) {
      params['type'] = rawData.type;
    }

    const classificationParams = Object.keys(this.selectedClassifications)
      .filter(key => this.selectedClassifications[key])
      .map(key => ({
        parent: Number(key),
        child: this.selectedClassifications[key]
      }));

    if (classificationParams.length > 0) {
      params['classification'] = JSON.stringify(classificationParams);
    }

    this.employeeService.tnaAuthorisationList(params).subscribe({
      next: resp => {
        this.empAttendanceList = (resp?.data?.rows || []).map((item: any) => {
          const otData: any = {};
          for (const ot of this.otList) {
            otData[`ot_${ot.id}`] = this.getOtDisplay(item, ot.id) || '---';
          }
          const clsData: any = {};
          for (const cls of this.classificationList) {
            clsData[`cls_${cls.id}`] = this.getChildName(item, cls.id);
          }
          return {
            ...item,
            calendar_date_str: item.attendance?.calendar_date
              ? this.datePipe.transform(new Date(item.attendance.calendar_date), this.angularDateFormat || 'dd/MM/yyyy', 'UTC') || ''
              : '---',
            shift_start_str: item.shift_config?.start_time
              ? (this.datePipe.transform(this.convertToDate(item.shift_config.start_time), 'hh:mm a') || '--')
              : '--',
            shift_end_str: item.shift_config?.end_time
              ? (this.datePipe.transform(this.convertToDate(item.shift_config.end_time), 'hh:mm a') || '--')
              : '--',
            checkin_str: item.attendance?.checkin_time
              ? (this.datePipe.transform(new Date(item.attendance.checkin_time), 'hh:mm a', 'UTC') || '--')
              : '--',
            checkout_str: item.attendance?.checkout_time
              ? (this.datePipe.transform(new Date(item.attendance.checkout_time), 'hh:mm a', 'UTC') || '--')
              : '--',
            ...otData,
            ...clsData,
          };
        });
        this.totalRecords = resp?.data?.totalItems || 0;
        this.currentPage = resp?.data.currentPage;
        if (this.myColumns.length === 0) this.buildTnaColumns();
      }
    });
  }

  buildTnaColumns(): void {
    const staticCols: any[] = [
      { field: 'action', header: 'Actions' },
      { field: 'employee_id', header: 'Employee' },
      { field: 'emp_code_col', header: 'Employee Code', isdynamic: true, parentvalues: 'employee.employeecode' },
      { field: 'calendar_date_str', header: 'Calendar Date', isDate: true, filterField: 'attendance.calendar_date' },
      { field: 'att_day', header: 'Day', isdynamic: true, parentvalues: 'attendance.calendar_day' },
      { field: 'tna_shift', header: 'Shift', isdynamic: true, parentvalues: 'shift_config.shift_name' },
      { field: 'shift_start_str', header: 'Start Time', isTime: true, filterField: 'shift_config.start_time' },
      { field: 'shift_end_str', header: 'End Time', isTime: true, filterField: 'shift_config.end_time' },
      { field: 'wrk_hours', header: 'No of Working Hours', isdynamic: true, parentvalues: 'shift_config.working_hours' },
      { field: 'checkin_str', header: 'Check-In Time', isTime: true, filterField: 'attendance.checkin_time' },
      { field: 'checkout_str', header: 'Check-Out Time', isTime: true, filterField: 'attendance.checkout_time' },
      { field: 'actual_hours', header: 'Actual Working Hours', isdynamic: true, parentvalues: 'attendance.total_hours_worked' },
      { field: 'remarks', header: 'Remarks', isdynamic: true, parentvalues: 'attendance.remarks' },
      { field: 'late_hours', header: 'Late Hours', isdynamic: true, parentvalues: 'attendance.late_hours' },
    ];
    const otCols = this.otList.map((ot: any) => ({
      field: `ot_${ot.id}`, header: ot.ot_name
    }));
    const extraCols: any[] = [
      { field: 'extra_hours', header: 'Extra Hours', isdynamic: true, parentvalues: 'attendance.overtime_hours' },
      { field: 'att_status', header: 'Attendance Status', isdynamic: true, parentvalues: 'attendance.attendance_status' },
    ];
    const clsCols = this.classificationList.map((cls: any) => ({
      field: `cls_${cls.id}`, header: cls.name
    }));
    this.myColumns = [...staticCols, ...otCols, ...extraCols, ...clsCols];
  }

  handleFilterChange(payload: any): void {
    this.filterPayload = payload;
    if (payload) {
      if (payload.orderby !== undefined) this.orderby = payload.orderby;
      if (payload.order !== undefined) this.order = payload.order;
      if (payload.page !== undefined) {
        this.currentPage = payload.page;
        this.page = payload.page + 1;
      }
      if (payload.pageSize !== undefined) {
        this.pageSize = payload.pageSize;
        this.size = payload.pageSize;
      }
    }
    this.list();
  }

  onSearchChange(): void {
    if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
    this.searchDebounceTimer = setTimeout(() => {
      this.currentPage = 0;
      this.page = 1;
      this.list();
    }, 400);
  }

  handlePageChange(newPage: number): void {
    this.currentPage = newPage > 0 ? newPage - 1 : 0;
    this.page = newPage;
    this.refreshData();
  }

  convertToDate(timeString: any): Date | null {
    if (!timeString) return null;
    return moment(timeString, "HH:mm:ss").toDate();
  }

  getChildName(emp: any, parentId: any): string {
    const found = emp.classification?.find((c: any) => c.parent == parentId);
    return found?.child_name || '---';
  }

  applyEmployeeNameFilter(): void { }

  onEmployeeNameFilterChange(): void {
    this.applyEmployeeNameFilter();
  }

  // checkbox functionality
  selectedIds: Set<any> = new Set();
  allSelected = false;

  // Stable function reference passed to custom-table [isRowChecked]
  isRowCheckedFn = (row: any): boolean => this.selectedIds.has(row._id);

  get someChecked(): boolean {
    return this.selectedIds.size > 0 && this.selectedIds.size < this.empAttendanceList.length;
  }

  // Called from custom-table (checkAllChange)
  onCheckAllChange(checked: boolean): void {
    if (checked) {
      this.selectedIds = new Set(this.empAttendanceList.map((emp: any) => emp?._id));
    } else {
      this.selectedIds = new Set();
    }
    this.allSelected = checked;
  }

  // Called from custom-table (rowCheckChange)
  onRowCheckChange(row: any): void {
    const newSet = new Set(this.selectedIds);
    if (newSet.has(row._id)) {
      newSet.delete(row._id);
    } else {
      newSet.add(row._id);
    }
    this.selectedIds = newSet;
    this.allSelected = this.selectedIds.size === this.empAttendanceList.length;
  }

  toggleAllSelection() {
    this.onCheckAllChange(!this.allSelected);
  }

  toggleEmployeeSelection(empId: any) {
    const newSet = new Set(this.selectedIds);
    if (newSet.has(empId)) {
      newSet.delete(empId);
    } else {
      newSet.add(empId);
    }
    this.selectedIds = newSet;
    this.allSelected = this.selectedIds.size === this.empAttendanceList.length;
  }

  isEmployeeSelected(empId: any): boolean {
    return this.selectedIds.has(empId);
  }

  formPresentOrAbsent(type: any) {
    const rawValue = this.tnaForm.getRawValue();
    rawValue.remarks?.trim()
    if (!rawValue.remarks) {
      return this.toastService.failure('Please fill in the remarks');
    }

    Swal.fire({
      title: `Are you sure you want to update attendance as ${type}?`,
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, update it!',
      cancelButtonText: 'No, cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        const formData: any = {
          ids: Array.from(this.selectedIds), // array of _ids from the table
          attendance_status: type,
          remarks: rawValue.remarks.trim(),
          company_id: rawValue.company_id
        };

        this.employeeService.bulkUpdate(formData).subscribe({
          next: (resp: any) => {
            this.toastService.success('Updated successfully!');
            this.refreshData();
            this.selectedIds = new Set();
            this.allSelected = false;
            this.tnaForm?.patchValue({
              remarks: '',
            });
          },
          error: (err: { error: { message: string } }) => {
            this.toastService.failure(err.error?.message || 'Something went wrong');
          },
        });
      }
    });
  }

  get hasSelected(): boolean {
    return Array.isArray(this.selectedIds)
      ? this.selectedIds.length > 0
      : this.selectedIds.size > 0;
  }

  checkPermission(type: string) {
    return this.auth.checkPermission(type);
  }

  deleteClick(id: string) {
    Swal.fire({
      title: `Are you sure you want delete?`,
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel',
    }).then((result) => {
      if (result.isConfirmed) {

        this.employeeService.deleteTempCalendar(id).subscribe({
          next: (resp: any) => {
            this.toastService.success('Deleted successfully!');
            this.refreshData();
            this.selectedIds = new Set();
            this.allSelected = false;
            this.tnaForm?.patchValue({
              remarks: '',
            });
          },
          error: (err: { error: { message: string } }) => {
            this.toastService.failure(err.error?.message || 'Something went wrong');
          },
        });
      }
    });
  }

  // --- Edit single attendance times modal logic ---
  @ViewChild('tnaStartPicker') tnaStartPicker!: NgxMaterialTimepickerComponent;
  @ViewChild('tnaEndPicker') tnaEndPicker!: NgxMaterialTimepickerComponent;
  @ViewChild('tnaEditModal') tnaEditModal: any;
  editRecordId: any = null;
  formKey: string = 'tnaAuthorisation';
  formisDisable: boolean = false;

  isFormChanged() {
    this.formisDisable = this.formChangeService.hasChanged(this.formKey, this.editTnaForm);
  }

  private setupFormChangeTracking(): void {
    this.editTnaForm.valueChanges.subscribe(() => {
      this.formisDisable = this.formChangeService.hasChanged(
        this.formKey,
        this.editTnaForm
      );
    });
  }

  viewData: any = ''
  openEditModal(item: any, content?: any) {
    // Reset errors and touched state
    this.editTnaForm.reset();
    this.viewData = item;

    // Patch existing values (convert to HH:mm if necessary)
    const checkin = this.formatForPicker(item?.attendance?.checkin_time);
    const checkout = this.formatForPicker(item?.attendance?.checkout_time);
    console.log("=--=item", item);

    this.editTnaForm.patchValue({
      checkin_time: checkin || null,
      checkout_time: checkout || null,
      remarks: item?.attendance?.remarks || null
    });
    this.formChangeService.resetForm(this.formKey, this.editTnaForm);
    this.isFormChanged();
    // Open modal template (refer to template #tnaEditModal)
    this.modalService.open((<any>this).tnaEditModal, { size: 'md' });
  }

  private formatForPicker(timeStr: string | null): string | null {
    if (!timeStr) return null;
    try {
      const m = moment.utc(timeStr, moment.ISO_8601, true);

      if (m.isValid()) {
        return m.format('HH:mm');
      }

      const parts = timeStr.split(':');
      if (parts.length >= 2) return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}`;

      return null;
    } catch {
      return null;
    }
  }

  saveEditTna() {
    if (this.editTnaForm.invalid) return;

    const raw = this.editTnaForm.getRawValue();

    // Convert to 24-hour time
    const checkin = moment(raw.checkin_time, ["hh:mm A", "h:mm A"]).format("HH:mm");
    const checkout = moment(raw.checkout_time, ["hh:mm A", "h:mm A"]).format("HH:mm");

    const date = this.viewData?.attendance?.calendar_date;

    // Create moment objects for comparison
    const checkinMoment = moment(`${date} ${checkin}`, "YYYY-MM-DD HH:mm");
    let checkoutMoment = moment(`${date} ${checkout}`, "YYYY-MM-DD HH:mm");

    // 🔥 If checkout time is before check-in, it means next day
    if (checkoutMoment.isBefore(checkinMoment)) {
      checkoutMoment = checkoutMoment.add(1, "day");
    }

    const payload = {
      checkin_time: checkinMoment.format("YYYY-MM-DD HH:mm:ss"),
      checkout_time: checkoutMoment.format("YYYY-MM-DD HH:mm:ss"),
      remarks: raw.remarks
    };


    // Optionally log for debug
    this.employeeService.updateTnaAuthorisation(payload, this.viewData?._id).subscribe({
      next: (resp) => {
        this.toastService.success(resp?.message || 'Updated successfully');
        this.modalService.dismissAll();
        this.refreshData();
        this.viewData = ''
      },
      error: (err) => {
        this.toastService.failure(err?.error?.message || 'Something went wrong');
      }
    });
  }

  pullRawData() {
    Swal.fire({
      title: `Are you sure you want to pull the raw attendance data?`,
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No, cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        this.employeeService.pullRawData().subscribe({
          next: (resp: any) => {
            this.toastService.success('Pulled successfully!');
            this.refreshData();
            this.selectedIds = new Set();
            this.allSelected = false;
            this.tnaForm?.patchValue({
              remarks: '',
            });
          },
          error: (err: { error: { message: string } }) => {
            this.toastService.failure(err.error?.message || 'Something went wrong');
          },
        });
      }
    });
  }

  postToMainAttendanceDb(type: any) {
    let selectedIds = Array.from(this.selectedIds)
    if (type == 'Post' && selectedIds.length == 0) {
      return this.toastService.failure('Select any one item from list');
    }
    let rawData = this.tnaForm.getRawValue();
    Swal.fire({
      title: `Are you sure you want to ${type}?`,
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: `Yes, ${type}!`,
      cancelButtonText: 'No, cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        const formData: any = {
          ids: selectedIds, // array of _ids from the table
          type: type,
          company_id: rawData?.company_id,
          start_date: this.formatDate(rawData.start_date),
          end_date: this.formatDate(rawData.end_date)
        };

        this.employeeService.syncToAttendanceDb(formData).subscribe({
          next: (resp: any) => {
            this.toastService.success('Posted successfully!');
            this.refreshData();
            this.selectedIds = new Set();
            this.allSelected = false;
            this.tnaForm?.patchValue({
              remarks: '',
            });
          },
          error: (err: { error: { message: string } }) => {
            this.toastService.failure(err.error?.message || 'Something went wrong');
          },
        });
      }
    });
  }

  getOtList(id: any) {
    this.otMasterService.getAllOtList({ company_id: id }).subscribe({
      next: resp => {
        this.otList = (resp?.data ?? []).sort((a: any, b: any) => a.id - b.id);
      }
    })
  }

  getOtDisplay(item: any, otId: number): string {
    const ot = item?.ot_config?.find((o: any) => o.ot_id === otId);
    if (!ot || ot.ot_hours == null) {
      return '---';
    }
    const hours = Number(ot.ot_hours);
    if (isNaN(hours)) {
      return '---';
    }
    const label = hours === 1 ? 'Hour' : 'Hours';
    return `${hours} ${label}`;
  }

  downloadExcel() {
    const rawData = this.tnaForm.getRawValue();
    const start_date = this.formatDate(this.tnaForm.get('start_date')?.value);
    const end_date = this.formatDate(this.tnaForm.get('end_date')?.value);

    const params: any = {
      company_id: rawData.company_id,
      start_date,
      end_date,
      page: 0,
      size: this.totalRecords || 100000
    };
    if (rawData.employee_id) params['employee_id'] = rawData.employee_id;
    if (rawData.type) params['type'] = rawData.type;

    this.employeeService.tnaAuthorisationList(params).subscribe({
      next: (resp: any) => {
        const allRecords = resp?.data?.rows || [];
        this.generateExcel(allRecords);
      },
      error: () => {
        this.toastService.failure('Failed to fetch data for export');
      }
    });
  }

  private generateExcel(empAttendanceList: any[]) {
    const data: any[][] = [];
    const merges: XLSX.Range[] = [];

    /* ================= GET ALL OT TYPES ================= */
    const otSet = new Set<string>();

    empAttendanceList.forEach((item: any) => {
      item.ot_config?.forEach((ot: any) => {
        if (ot?.ot_name) otSet.add(ot.ot_name);
      });
    });
    const otColumns = Array.from(otSet); // ['OT 1', 'OT 2', ...]

    const classSet = new Set<string>();

    empAttendanceList.forEach((item: any) => {
      item.classification?.forEach((c: any) => {
        if (c?.parent_name) classSet.add(c.parent_name);
      });
    });

    const classColumns = Array.from(classSet);

    /* ================= TITLE ================= */
    const titleRow = data.length;
    data.push(['Attendance Report']);
    data.push([]);

    /* ================= HEADER ================= */
    const headerRowIndex = data.length;

    const header = [
      'S.No',
      'Employee Name',
      'Employee Code',
      'Calendar Date',
      'Day',
      'Shift',
      'Start Time',
      'End Time',
      'No of Working Hours',
      'Check-In Time',
      'Check-Out Time',
      'Actual Working Hours',
      'Remarks',
      'Late Hours',
      ...otColumns,
      'Extra Hours',
      'Attendance Status',
      ...classColumns,
    ];

    data.push(header);

    /* ================= DATA ================= */
    empAttendanceList.forEach((item: any, index: number) => {

      // Create OT map
      const otMap: any = {};
      item.ot_config?.forEach((ot: any) => {
        otMap[ot.ot_name] = `${ot.ot_hours} Hour`;
      });

      const classMap: any = {};
      item.classification?.forEach((c: any) => {
        classMap[c.parent_name] = c.child_name;
      });

      data.push([
        index + 1,
        item.employee?.firstname || '',
        item.employee?.employeecode || '',
        new Date(item.attendance?.calendar_date).toLocaleDateString(),
        item.attendance?.calendar_day || '',
        item.shift_config?.shift_name || '',
        item.shift_config?.start_time || '',
        item.shift_config?.end_time || '',
        item.shift_config?.working_hours || '',
        item.attendance?.checkin_time || '---',
        item.attendance?.checkout_time || '---',
        item.attendance?.total_hours_worked || '00:00',
        item.attendance?.remarks || '---',
        item.attendance?.late_hours || '---',

        // 🔥 Dynamic OT values aligned with header
        ...otColumns.map(col => otMap[col] || '---'),

        item.attendance?.overtime_hours || '00:00',
        item.attendance?.attendance_status || '',
        ...classColumns.map(col => classMap[col] || '---')
      ]);
    });

    /* ================= WORKSHEET ================= */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);

    /* ================= MERGE TITLE ================= */
    const maxCols = header.length;

    merges.push({
      s: { r: titleRow, c: 0 },
      e: { r: titleRow, c: maxCols - 1 }
    });

    ws['!merges'] = merges;

    /* ================= STYLES ================= */
    const range = XLSX.utils.decode_range(ws['!ref']!);

    const border = {
      top: { style: 'thin' },
      bottom: { style: 'thin' },
      left: { style: 'thin' },
      right: { style: 'thin' }
    };

    for (let r = range.s.r; r <= range.e.r; r++) {
      for (let c = range.s.c; c <= range.e.c; c++) {

        const ref = XLSX.utils.encode_cell({ r, c });
        const cell = ws[ref];
        if (!cell) continue;

        cell.s = {
          border,
          font: { name: 'Calibri', sz: 11 },
          alignment: {
            vertical: 'center',
            horizontal: c === 0 ? 'left' : 'center',
            wrapText: true
          }
        };

        /* Title */
        if (r === titleRow) {
          cell.s.font = { bold: true, sz: 14 };
          cell.s.alignment.horizontal = 'center';
        }

        /* Header */
        if (r === headerRowIndex) {
          cell.s.font = { bold: true };
          cell.s.fill = { fgColor: { rgb: 'D9E1F2' } };
        }

        /* Absent highlight */
        if (
          header[c] === 'Attendance Status' &&
          cell.v === 'Absent'
        ) {
          cell.s.fill = { fgColor: { rgb: 'FFC7CE' } };
          cell.s.font = { bold: true };
        }
      }
    }

    /* ================= COLUMN WIDTH ================= */
    ws['!cols'] = Array(maxCols).fill({ wch: 16 });

    /* ================= WORKBOOK ================= */
    const wb: XLSX.WorkBook = {
      Sheets: { 'Attendance Report': ws },
      SheetNames: ['Attendance Report']
    };

    const buffer = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array'
    });

    saveAs(
      new Blob([buffer], { type: 'application/octet-stream' }),
      'Attendance_Report.xlsx'
    );
  }

  // downloadExcel() {
  //   if (this.empAttendanceList?.length) {
  //     this.excelService.jsonToExcel(this.empAttendanceList, 'Attendance_Report');
  //   }
  // }

}
